module.exports = __webpack_public_path__ + "c92b0bcc3be2fa210ee3fd208b8b6215.MP3";